import { Component, ViewContainerRef, ComponentFactoryResolver, ViewChild, HostBinding, Input } from '@angular/core';
import { WidgetsHostDirective } from './widgetshost.component';
import { SolarComponent } from '../solar/solar.component';

@Component({
   selector: 'div[int-dashboard=widget]',
   template: '<ng-template widgets-host></ng-template>',
//   host: {'class': 'row'}
})
export class WidgetHolderComponent {

    @ViewChild(WidgetsHostDirective, { static: true }) widgetsHost: WidgetsHostDirective;

    @HostBinding('class')
    @Input('class')
    classList: string = '';

   constructor(
     public viewContainerRef: ViewContainerRef,
  //   private componentFactoryResolver: ComponentFactoryResolver
    ) { }

    ngOnInit() {
    //   const componentFactory = this.componentFactoryResolver.resolveComponentFactory(SolarComponent);

    //   const viewContainerRef = this.widgetsHost.viewContainerRef;
    //   viewContainerRef.clear();

    //   viewContainerRef.createComponent(componentFactory);
    }
}
